var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      !_vm.loading && _vm.records
        ? _c("div", { staticClass: "card-body" }, [
            _c("table", { staticClass: "table table-sm table-hover" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.$AllDivisions, function (division) {
                  return division.is_active
                    ? _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.mixinGetDivisionName(division)) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            !_vm.records[division.id].data.free_days ||
                            !_vm.records[division.id].data.free_days.length
                              ? _c("div", [_c("p", [_vm._v("Без выходных")])])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(
                              _vm.records[division.id].data.free_days,
                              function (record, index) {
                                return _c(
                                  "div",
                                  { staticClass: "flex" },
                                  [
                                    !record.delete
                                      ? [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: record.city_id,
                                                  expression: "record.city_id",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    record,
                                                    "city_id",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                { domProps: { value: 0 } },
                                                [_vm._v("Все города")]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                division.cities,
                                                function (c, i) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      domProps: {
                                                        value: c.city.id,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(c.city.name)
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: record.day_num,
                                                  expression: "record.day_num",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    record,
                                                    "day_num",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            _vm._l(
                                              _vm.days,
                                              function (name, num) {
                                                return _c(
                                                  "option",
                                                  { domProps: { value: num } },
                                                  [_vm._v(_vm._s(name))]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "small_w" },
                                            [
                                              _c("TimeSelect", {
                                                attrs: {
                                                  selectedDate: record.time,
                                                  onSelect: (time) =>
                                                    (record.time = time),
                                                  disabled: true,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-outline-danger",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteRecord(
                                                    division.id,
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-trash-o",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              }
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-info btn-sm",
                              on: {
                                click: function ($event) {
                                  return _vm.addNewRecord(division.id)
                                },
                              },
                            },
                            [_vm._v("добавить запись")]
                          ),
                        ]),
                      ])
                    : _vm._e()
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _c("LoadingButton", {
                  attrs: {
                    title: "Сохранить",
                    className: "btn btn-success btn-xs mb-1",
                    onClick: _vm.updateRecords,
                    loading: _vm.btnLoading,
                    color: "white",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Настройки графика работы дивизионов")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Дивизион")]),
        _vm._v(" "),
        _c("th", [_vm._v("Выходные")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }